import React, { useState } from "react";

import { BugReportModal } from "./BugReportModal";

type BugReportButtonVariant = "settings" | "header";

type BugReportButtonProps = {
  variant?: BugReportButtonVariant;
};

const VARIANT_CLASSNAMES: Record<BugReportButtonVariant, string> = {
  settings: "tw-flex tw-cursor-pointer tw-items-center tw-gap-2",
  header:
    "tw-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-full tw-px-3 tw-py-1 tw-text-sm tw-text-gray-600 hover:tw-bg-gray-100 hover:tw-text-gray-900",
};

const VARIANT_TEST_IDS: Record<BugReportButtonVariant, string> = {
  settings: "bug-report-button",
  header: "bug-report-button-header",
};

export const BugReportButton: React.FC<BugReportButtonProps> = ({
  variant = "settings",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = (): void => setIsOpen(true);
  const openOnKey = (event: React.KeyboardEvent): void => {
    if (event.key === "Enter" || event.key === " ") {
      open();
    }
  };

  return (
    <>
      <a
        role="button"
        tabIndex={0}
        data-testid={VARIANT_TEST_IDS[variant]}
        aria-label="Report a bug"
        className={VARIANT_CLASSNAMES[variant]}
        onClick={open}
        onKeyDown={openOnKey}
      >
        <i className="material-icons tw-text-lg tw-leading-[1]">bug_report</i>
        Report a bug
      </a>
      {isOpen && <BugReportModal onClose={(): void => setIsOpen(false)} />}
    </>
  );
};
